var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wsod"},[_c('div',{staticClass:"msg my-auto"},[_c('font-awesome-icon',{attrs:{"icon":{ prefix: 'far', iconName: 'frown' },"size":"2x"}}),_c('p',[_vm._v("404 Trove Not Found")]),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("[ "),_c('a',{attrs:{"href":"/"}},[_vm._v("Retry")]),_vm._v(" ]")])
}]

export { render, staticRenderFns }